import { IEvents } from "@walletconnect/jsonrpc-types";
export class ISubscriberTopicMap {
    constructor() {
        this.map = new Map();
    }
}
export class ISubscriber extends IEvents {
    constructor(relayer, logger) {
        super();
        this.relayer = relayer;
        this.logger = logger;
    }
}
//# sourceMappingURL=subscriber.js.map